/**
 * The support vocabularies, in Spanish, keyed by the contract — Task 13.2.
 *
 * `Record<SupportRequestStatus, string>` rather than a lookup with a fallback: adding a status to the contract
 * should stop this compiling, not render `spam` to a staff member because nobody remembered to label it.
 */
import type {
  SupportRequestCategory,
  SupportRequestStatus,
  SupportSideEffectStatus,
} from '@apuestapr/contracts';

export const supportStatusLabels: Readonly<Record<SupportRequestStatus, string>> = {
  new: 'Nueva',
  in_progress: 'En progreso',
  resolved: 'Resuelta',
  closed: 'Cerrada',
  spam: 'Spam',
};

export const supportCategoryLabels: Readonly<Record<SupportRequestCategory, string>> = {
  general: 'Consulta general',
  support: 'Ayuda con cuenta o apuestas',
  account_deletion: 'Eliminación de cuenta',
};

export const supportSideEffectLabels: Readonly<Record<SupportSideEffectStatus, string>> = {
  disabled: 'Desactivado',
  pending: 'Pendiente',
  succeeded: 'Completado',
  failed: 'Falló',
};

/**
 * The badge treatment per status, paired with a shape so the state is never carried by colour alone.
 *
 * `resolved` and `closed` are both finished and share `accent`; the shape distinguishes them. `spam` is the
 * only destructive one, because it is the only status that says the request was not real.
 */
export const supportStatusBadge: Readonly<
  Record<
    SupportRequestStatus,
    {
      readonly variant: 'neutral' | 'accent' | 'destructive' | 'outline';
      readonly shape: 'circle' | 'diamond' | 'square';
    }
  >
> = {
  new: { variant: 'outline', shape: 'circle' },
  in_progress: { variant: 'neutral', shape: 'diamond' },
  resolved: { variant: 'accent', shape: 'square' },
  closed: { variant: 'accent', shape: 'circle' },
  spam: { variant: 'destructive', shape: 'diamond' },
};
